import type { ChecklistDocument, EstateRow } from '@acasa/shared'

const STATE_LABEL = { done: 'vorhanden', open: 'offen', not_applicable: 'n/a' } as const

/** Excel opens semicolon-separated files correctly in German locales. */
const SEPARATOR = ';'

function cell(value: string | number | null | undefined): string {
  const text = String(value ?? '')
  return /[";\n]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text
}

/**
 * Exports exactly what is on screen — the filtered, sorted rows and the chosen
 * document columns — so the file matches what the user is looking at.
 */
export function exportChecklistCsv(estates: EstateRow[], documents: ChecklistDocument[]) {
  const header = [
    'ImmoNr',
    'Objekt',
    'Art',
    'Vermarktung',
    'PLZ',
    'Ort',
    'Status',
    'Aktiv/Inaktiv',
    'Betreuer',
    'Angelegt',
    'Geändert',
    'Verkauft am',
    'Offen',
    'Vorhanden',
    'Nicht erforderlich',
    'Gesamt',
    ...documents.map((document) => document.label),
  ]

  const rows = estates.map((estate) => [
    estate.externalNumber ?? `#${estate.estateId}`,
    estate.title,
    estate.type,
    estate.marketingType,
    estate.postalCode,
    estate.city,
    estate.status,
    estate.activeState,
    estate.agent,
    estate.createdAt ? new Date(estate.createdAt).toLocaleDateString('de-DE') : '',
    estate.modifiedAt ? new Date(estate.modifiedAt).toLocaleDateString('de-DE') : '',
    estate.soldAt ? new Date(estate.soldAt).toLocaleDateString('de-DE') : '',
    estate.openCount,
    estate.doneCount,
    estate.notApplicableCount,
    estate.totalCount,
    ...documents.map((document) => {
      const step = estate.steps[document.key]
      const label = STATE_LABEL[step?.state ?? 'open']
      return step?.note ? `${label} (${step.note})` : label
    }),
  ])

  // BOM so Excel detects UTF-8 and renders umlauts correctly.
  const csv = `﻿${[header, ...rows].map((row) => row.map(cell).join(SEPARATOR)).join('\r\n')}`

  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }))
  const link = document.createElement('a')
  const stamp = new Date().toISOString().slice(0, 10)

  link.href = url
  link.download = `unterlagen-${stamp}.csv`
  link.click()
  URL.revokeObjectURL(url)
}
